export const SurveyEdit = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 14V6C24 4.89543 23.1046 4 22 4H7C5.89543 4 5 4.89543 5 6V27C5 28.1046 5.89543 29 7 29H13" stroke="currentColor" stroke-width="2"/>
<path d="M8 8L21 8" stroke="currentColor" stroke-width="2"/>
<path d="M8 12L21 12" stroke="currentColor" stroke-width="2"/>
<path d="M8 16H16" stroke="currentColor" stroke-width="2"/>
<path d="M8 25H13" stroke="currentColor" stroke-width="2"/>
<path d="M19 29H16V26L24.9292 17.0708C24.9683 17.0317 25.0317 17.0317 25.0707 17.0708L27.9343 19.9385C27.9734 19.9775 27.9733 20.0409 27.9342 20.0799L19 29Z" stroke="currentColor" stroke-width="2"/>
<path d="M25 23L21.5 19.5" stroke="currentColor" stroke-width="2"/>
</svg>`;
